var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 134 202",
    style: {
      enableBackground: "new 0 0 664.3 202.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#133444;}\n\t.st1{fill:#C42370;}\n\t.st2{fill:#1C4D6B;}\n\t.st3{fill:#1D4259;}\n\t.st4{fill:#4B6B9A;}\n\t.st5{fill:#343535;}\n\t.st6{fill:#3E5578;}\n\t.st7{fill:#6DB2D8;}\n\t.st8{fill:#335F8A;}\n\t.st9{fill:#529BBA;}\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1.9,116.3 6.8,114.2 66.8,88.1 131.7,116.3 107.3,166.7 47.7,175.1 2.9,126.7     "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.2,85.3C107.5,72.4,92.3,64,75.7,61.8c-0.4,0-0.7-0.1-1.1-0.1c-5.2-0.6-10.4-0.6-15.6,0      c-0.4,0-0.7,0.1-1.1,0.1C41.3,64,26.1,72.4,15.4,85.3l0,0l-2.7,4.5l-4.5,7.5l-3.3,5.5l0,0c0,0.2-0.1,0.3-0.2,0.4v0.1l7.2,4.3      l46,27.2l8.9,5.2V75l-8.9,4v-9.7l8.9-4l8.9,4l45.2,20.5L118.2,85.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.7,132.5c-0.1,21.3-9.7,41.4-26.2,54.9c-6.3,5.1-13.4,9.1-21.1,11.7c-6.3,2.1-12.9,3.2-19.5,3.2      c-37,0-66.9-32.9-66.9-69.8c0-5.5,0.7-10.9,2-16.2l64.9,38.4l64.9-38.4C133,121.6,133.7,127,133.7,132.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59,61.6 66.8,65.2 57.9,69.2 57.9,61.2     "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.9,79 66.8,74.9 66.8,139.9 57.9,134.7     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "66.8,74.9 66.8,139.9 129,103.2     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "66.8,0 66.8,74.9 129,103.2     "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M66.8,74.9v65l-8.9-5.2L4.7,103.2l0,0c0-0.2,0.1-0.3,0.2-0.4l0,0l7.8-12.9l45.2-20.5v9.8L66.8,74.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "66.8,74.9 66.8,139.9 57.9,134.7 4.7,103.2 4.6,103.2 4.7,103.1 57.9,79     "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "66.8,0 66.8,74.9 4.6,103.2     "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M41.6,197c0.9,0.4,1.9,0.8,2.8,1.2C43.5,197.8,42.6,197.4,41.6,197z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M44.4,198.1c0.9,0.4,1.9,0.7,2.9,1C46.3,198.8,45.4,198.5,44.4,198.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M49.8,199.9c0.8,0.2,1.5,0.4,2.2,0.6L49.8,199.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1.9,116.3l64.9,38.4c-0.9,5.8-2.4,11.5-4.7,17c-5.2,12.6-15.7,25.8-36,15.7l0,0      C9.6,173.9,0,153.7-0.1,132.4C-0.1,127,0.6,121.6,1.9,116.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M107.3,187.5L107.3,187.5c-0.4,0.3,0,0-1.3,1.1l-0.6,0.4l-0.9,0.6l-1.1,0.8c1.1-0.8-0.9,0.6-1.3,0.9      c-0.4,0.2-0.7,0.4-1.1,0.7l-0.7,0.5c-0.2,0.1-0.5,0.3-0.7,0.5c0,0-0.3,0.3-0.4,0.3c0.4-0.3-0.5,0.2-0.9,0.5      c-0.5,0.2-0.9,0.4-1.3,0.7l-1.4,0.7l-0.6,0.3c-0.4,0.2-0.2,0-0.6,0.3s-0.9,0.4-1.4,0.7s0,0-1.7,0.8c1.7-0.8,0,0-0.9,0.4      c0.9-0.4-1.6,0.6-2.7,1c-0.4,0.1-2.6,0.8-3,0.9s-0.9,0.3-1.3,0.4c-0.8,0.2-1.5,0.4-2.2,0.6c-0.3,0.1-0.6,0.1-0.8,0.2l-0.5,0.1      l-1.2,0.3c-0.4,0.1-0.7,0.1-1.1,0.2s-0.7,0.1-1,0.2s-0.8,0.1-1.1,0.2c-0.2,0-0.4,0-0.5,0.1l-0.8,0.1h-0.4      c-0.3,0-0.6,0.1-0.9,0.1s-0.8,0.1-1.2,0.1H61.5c-0.4,0-0.8-0.1-1.2-0.1c-0.3,0-0.6,0-0.9-0.1H59c-0.3,0-0.6-0.1-0.8-0.1      c-0.2,0-0.4,0-0.5-0.1c-0.4,0-0.7-0.1-1.1-0.2c-0.3,0-0.7-0.1-1-0.2c-0.3-0.1-0.7-0.1-1.1-0.2l-1.2-0.3l-0.5-0.1      c-0.3,0-0.6-0.1-0.8-0.2c-0.8-0.2-1.5-0.4-2.2-0.6l-1.3-0.4c-0.4-0.1-0.8-0.2-1.2-0.4c-1-0.3-1.9-0.7-2.9-1s-1.9-0.8-2.8-1.2      c-0.4-0.2-0.9-0.4-1.4-0.6c-0.5-0.2-1-0.4-1.4-0.7c-0.5-0.2-0.9-0.4-1.3-0.7l0,0c-0.4-0.2-0.9-0.5-1.3-0.7      c-0.4-0.2-0.7-0.4-1-0.6c-1-0.6-1.6-1-1-0.6l-0.6-0.4l-1.1-0.7l-0.4-0.2l-1-0.7c-0.4-0.3-0.8-0.5-1.2-0.8s-0.9-0.6-1.3-0.9      s-0.8-0.7-1.1-0.9l-0.4-0.3c-0.4-0.2-0.7-0.5-1-0.8l0,0c20.3,10.1,30.7-3.3,35.9-15.8c2.2-5.5,3.8-11.2,4.7-17      c0.9,5.9,2.4,11.7,4.7,17.2C76.8,184.2,87,197.5,107.3,187.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M81.6,200.5c0.8-0.2,1.5-0.4,2.2-0.6L81.6,200.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M86.3,199.1c1-0.3,1.9-0.6,2.9-1C88.2,198.5,87.3,198.8,86.3,199.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M89,198.2c0.9-0.4,2.1-0.8,3-1.3C91,197.4,89.9,197.8,89,198.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M133.7,132.5c-0.1,21.3-9.7,41.4-26.2,54.9c-20.3,10.1-30.8-3.2-36-15.7c-2.2-5.5-3.8-11.2-4.7-17      l64.9-38.4C133,121.6,133.7,127,133.7,132.5z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortis);
export default __webpack_public_path__ + "static/media/portis.7632e246e0990f0eca163214ba099d01.svg";
export { ForwardRef as ReactComponent };